import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../../app/services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { AfterViewInit, Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';

import * as $ from 'jquery';
window['jQuery'] = $;

import 'metismenu';
import 'jquery-slimscroll';
import { DialogService } from '../../services/modal-dialogs/dialog.service';
import { AddMemberDialog } from '../../dialogs/add.member/add.member.dialog';
import { UserRolesService } from '../../services/user.roles.service';
import * as moment from 'moment';

declare var __VERSION__: string;

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent implements OnInit, AfterViewInit {

    // USER ROLE VARIABLES
    isSupport: boolean = true;
    isAdmin: boolean = false;
    isDev: boolean = false;

    showDevMenu: boolean = false;

    devAccountEmails: string[] = [
        'michael@structurestudios.com',
        'fausto@structurestudios.com',
        'fausto2@structurestudios.com'
    ];

    VersionNumber = this.gb.Version;
    DatabaseMode: string;

    public UserType: string;
    public AdminFullName: string;

    @Output('AdvancedSearchClicked') AdvancedSearchClicked = new EventEmitter<boolean>();


    //Hotkey
    @HostListener('window:keydown.alt.k', ['$event'])
    addNoteHotkey(event: KeyboardEvent) {
        event.preventDefault();
        this.hotkeyLegend();
    }

    constructor( private router: Router, private sweetAlertService: SweetAlertService, public gb: GlobalService, private dialogService: DialogService, public roles: UserRolesService, private http: Http, private api: ssApiService, private sweetAlert: SweetAlertService ) { }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }

    ngOnInit() {
        this.AdminFullName = this.gb.FullName;

        this.checkUserRole();
        this.DatabaseModeCheck();
        // this.GravatarNow(this.gb.Email);
        // console.log("USER ROLE = ", this.roles.UserRole);

        let self = this;

        // setInterval(function() {
        //     let expiration = localStorage.getItem('override-api-exp');
        //     console.log(moment(expiration).isSameOrBefore(moment()));
        //     if(moment(expiration).isSameOrBefore(moment())) {
        //         self.sweetAlert.swal({
        //             'type' : 'warning',
        //             'title' : 'Live Server Expiration',
        //             'text' : 'You will now be logged out and the API will switch back to dev.',
        //             'showConfirmButton' : true,
        //             'showCancelButton' : true
        //         }).then( (confirm) => {
        //             console.log("should log you out");
        //         }, (dismiss) => {
        //             console.log("should extend 5 more minutes");
        //         })
        //     }
        // }, 3000)

        if (moment(localStorage.getItem('override-api-exp')).isBefore(moment())) {
            this.api.ClearLocalStorageURL();
        }
    }

    ngAfterViewInit(): void {


        (<any>$('#side-menu')).metisMenu();

        if ($('body').hasClass('fixed-sidebar')) {
            (<any>$('.sidebar-collapse')).slimscroll({
                height: '100%'
            })
        }
    }

    DatabaseModeCheck() {
        this.http.get(this.api.GetBaseURL() + 'admin/dbcontext').subscribe((response: any) => {
            this.DatabaseMode = JSON.parse(response._body).Data;
        });
    }

    IsDevAdmin(): boolean {
        return false;
    }

    onMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    createMemberAccount() {
        // console.log("Create New Member Account");
        let options = {
            height: 800
        }

        let disposable = this.dialogService.addDialog(AddMemberDialog, {}, options).subscribe(result => {

            disposable.unsubscribe();
            // console.log("createMemberAccount: ", result);

            if (result != undefined &&
                result != null &&
                result.Result) {

                // ok
                let memberID = Number.parseInt(result.Data);
                this.router.navigate(['/member-profile', memberID]);

            }

        });
    }

    checkUserRole() {
        // console.log("my user email ====== " + this.gb.Email);
        this.devAccountEmails.forEach(x => {
            if (x == this.gb.Email)
                this.isDev = true;
        })


    }

    logout() {
        // console.log("LOGOUT!");
        let disposable = this.api.Logout(false).subscribe(response => {
            disposable.unsubscribe();
            this.gb.Logout();
        }, error =>{
            this.gb.Logout();
        })
    }

    logoutForgetDevice() {
        // console.log("LOGOUT!");
        let disposable = this.api.Logout(true).subscribe(response => {
            disposable.unsubscribe();
            this.gb.Logout();
        }, error =>{
            this.gb.Logout();
        })
    }

    hotkeyLegend(){
        this.sweetAlertService.swal({
            title: 'Hotkey Legend',
            type: 'info',
            html: '<b><u>Everywhere</u></b><br /><b>Alt-K</b> => Hotkey Legend<br /><b>Alt-S</b> => Search Members<br /><br /><b><u>Member Record</u></b><br /><b>Alt-H</b> => Open Hubspot<br /><b>Alt-E</b> => Edit Member<br /><b>Alt-N</b> => Add Note<br /><b>Alt-M</b> => Request Member Review<br /><b>Alt-L</b> => Login As Member<br /><b>Alt-#</b> => Select Tab (i.e. Notes)<br /><br /><b><u>Editing a Note</u></b><br /><b>Alt-V</b> => Save Note<br /><br /><b><u>Editing a Ticket</u></b><br /><b>Alt-T</b> => Save Ticket<br /><b>Alt-C</b> => Close Ticket<br /><b>Alt-D</b> => Delete Ticket',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'OK',
        }).then((response: any) => { }, (dismiss) => { });        
    }    


    sessionExpireTest() {
        let newExpiration: Date = new Date();
        newExpiration.setSeconds( newExpiration.getSeconds() + 10);
        localStorage.setItem('crm_token_expiration', newExpiration.toString());
    }


    AdvancedSearch() {
        // this.AdvancedSearchClicked.emit(true);
        this.gb.AdvancedSearchClick();
        // console.log("AdvancedSearch() was fired");
    }

    ReloadPage() {
        window.location.reload();
    }

    ToggleDevMode() {
        this.gb.isDevMode = !this.gb.isDevMode;
        localStorage.setItem('ss-dev-mode', this.gb.isDevMode.toString());
    }

    ChangeServer() {
        if (this.IsLiveServer()) {
            this.api.ClearLocalStorageURL()
        } else {
            this.api.SetLocalStorageURL()
        }
        this.gb.Logout();
    }

    IsLiveServer() {
        if (localStorage.getItem('override-api-url')) {
            return true;
        }
        return false;
    }

    IsLocalHost() {
        if (window.location.hostname == 'localhost') {
            return true;
        } else {
            return false;
        }
    }

}
